import { asAnswersMap } from "features/Library/Common/QuestionsForm/Answers/AnswerProvider";
import { type IAnswerBase, type IAnswer } from "features/Library/Common/models";
import { SurveyAnswerType } from "features/Library/Surveys/types/models";
import { SurveyTextAnswer } from "features/Library/Surveys/SurveyDetails/SurveyContentForm/SurveyFields/SurveyTextAnswer";

/* istanbul ignore next */
export const AnswersMap = asAnswersMap({
  [SurveyAnswerType.Text]: {
    Component: SurveyTextAnswer,
    castAnswer: (answer: IAnswerBase) => answer as IAnswer<string>,
  },
});
